import type { WhitelabelVariantDefinition } from '../../types';

export const pagAmrlWhitelabel = {
  id: 'pag-amrl',
  colors: {
    primary: {
      900: '#532CA1',
      800: '#5F33BA',
      700: '#7F44F8',
      500: '#A378FA',
      300: '#CCB4FC',
      100: '#F2E8FB',
      contrastText: '#FFFFFF',
    },
  },
} as const;

export const pagAmrlDefaultTheme: WhitelabelVariantDefinition = {
  palette: {
    primary: {
      darker: pagAmrlWhitelabel.colors.primary[900],
      dark: pagAmrlWhitelabel.colors.primary[800],
      main: pagAmrlWhitelabel.colors.primary[700],
      light: pagAmrlWhitelabel.colors.primary[500],
      lighter: pagAmrlWhitelabel.colors.primary[300],
      muted: pagAmrlWhitelabel.colors.primary[100],
      contrastText: pagAmrlWhitelabel.colors.primary.contrastText,
    },
  },
};
